import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { env } from "../env";
import { getLocalStorage } from "../utils/function/localStorage";

export const settingApi = createApi({
  reducerPath: "settingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: env.BASE_URL,
    // mode: 'cors',
    prepareHeaders: (headers) => {
      headers.set("authorization", getLocalStorage("grow_boo_token"));
      return headers;
    },
  }),
  tagTypes: [
    "setting",
    "manage-roi",
    "manage-level-income",
    "manage-profit-sharing",
    "system-wallet",
  ], // automatic-data fetching
  endpoints: (builder) => ({
    // get popup image
    getPopupImage: builder.query({
      // SAST API
      query: () => "/api/v1/common/get_popup_img",
      providesTags: ["setting"], // automatic-data fetching
    }),
    getYoutube: builder.query({
      query: () => "/api/v1/public/get_video_link",
      providesTags: ["setting"], // automatic-data fetching
    }),
    getPdfLink: builder.query({
      query: () => "/api/v1/public/get_pdf_link",
      providesTags: ["setting"], // automatic-data fetching
    }),
    getWebsiteAnalytics: builder.query({
      query: () => "/api/v1/public/website_analytics",
    }),

    // get popup image
    getPopupImage: builder.query({
      // SAST API
      query: () => "/api/v1/common/get_popup_img",
      providesTags: ["setting"], // automatic-data fetching
    }),
    // admin
    addPopupImage: builder.mutation({
      query: (body) => ({
        url: "/api/v1/private/change_popup_img",
        method: "POST",
        body,
      }),
      invalidatesTags: ["setting"],
    }),
    // for admin to post image in home page
    createAdminHomepageImage: builder.mutation({
      query: (body) => ({
        url: "/api/v1/private/create_image",
        method: "POST",
        body,
      }),
      invalidatesTags: ["setting"],
    }),
    // for admin to post image in home page
    CreateAdminHomepageVideo: builder.mutation({
      query: (body) => ({
        url: "/api/v1/private/create_vedio",
        method: "POST",
        body,
      }),
      invalidatesTags: ["setting"],
    }),
    addYoutubeVideo: builder.mutation({
      query: (body) => ({
        url: "/api/v1/private/change_video_link",
        method: "POST",
        body,
      }),
      invalidatesTags: ["setting"],
    }),
    addPdfLink: builder.mutation({
      query: (body) => ({
        url: "/api/v1/private/change_pdf_link",
        method: "POST",
        body,
      }),
      invalidatesTags: ["setting"],
    }),
    addReward: builder.mutation({
      // SAST API
      query: (body) => ({
        url: "/api/v1/private/user/upload_reward_image",
        method: "POST",
        body,
      }),
      invalidatesTags: ["setting"],
    }),
    updateReward: builder.mutation({
      // SAST API
      query: (body) => ({
        url: "/api/v1/private/user/update_reward_image",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["setting"],
    }),
    deleteReward: builder.mutation({
      // SAST API
      query: (body) => ({
        url: "/api/v1/private/user/delete_reward_image",
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["setting"],
    }),
    deleteGalleryImageByAdmin: builder.mutation({
      // SAST API
      query: (body) => ({
        url: "/api/v1/private/delete_image_byId",
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["setting"],
    }),
    deleteGalleryVideoByAdmin: builder.mutation({
      // SAST API
      query: (body) => ({
        url: "/api/v1/private/delete_vedio_byId",
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["setting"],
    }),
    getAdminReward: builder.query({
      query: () => "/api/v1/private/user/get-all-rewards",
      providesTags: ["setting"], // automatic-data fetching
    }),
    getAdminAllPhotos: builder.query({
      query: () => "/api/v1/private/get_all_image",
      providesTags: ["setting"], // automatic-data fetching
    }),
    getAdminAllVideos: builder.query({
      query: () => "/api/v1/private/get_all_vedio",
      providesTags: ["setting"], // automatic-data fetching
    }),
    getYoutube: builder.query({
      query: () => "/api/v1/public/get_video_link",
      providesTags: ["setting"], // automatic-data fetching
    }),
    getPdfLink: builder.query({
      query: () => "/api/v1/public/get_pdf_link",
      providesTags: ["setting"], // automatic-data fetching
    }),
    getWebsiteAnalytics: builder.query({
      query: () => "/api/v1/public/website_analytics",
    }),

    // admin
    addManageROI: builder.mutation({
      query: (body) => ({
        url: "/api/v1/private/create-manage-roi",
        method: "POST",
        body,
      }),
      invalidatesTags: ["manage-roi"],
    }),

    getAllManageROIHistoryAdmin: builder.query({
      // SAST API
      query: (query) =>
        `/api/v1/private/get-manage-roi?page=${query?.page}&limit=${query?.limit}&searchById=${query.searchById}&startDate=${query.startDate}&endDate=${query.endDate}&csv=${query.csv}`,
      providesTags: ["manage-roi"], // automatic-data fetching
    }),

    deleteManageROI: builder.mutation({
      query: (body) => ({
        url: "/api/v1/private/delete-manage-roi",
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["manage-roi"],
    }),

    editManageROI: builder.mutation({
      query: (body) => ({
        url: "/api/v1/private/edit-manage-roi",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["manage-roi"],
    }),

    // admin
    addManageLevelIncome: builder.mutation({
      query: (body) => ({
        url: "/api/v1/private/create-manage-level-income",
        method: "POST",
        body,
      }),
      invalidatesTags: ["manage-level-income"],
    }),
    getAllManageLevelIncomeHistoryAdmin: builder.query({
      // SAST API
      query: (query) =>
        `/api/v1/private/get-manage-level-income?page=${query?.page}&limit=${query?.limit}&searchById=${query.searchById}&startDate=${query.startDate}&endDate=${query.endDate}&csv=${query.csv}&type=${query.type}`,
      providesTags: ["manage-level-income"], // automatic-data fetching
    }),
    deleteManageLevelIncome: builder.mutation({
      query: (body) => ({
        url: "/api/v1/private/delete-manage-level-income",
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["manage-level-income"],
    }),
    editManageLevelIncome: builder.mutation({
      query: (body) => ({
        url: "/api/v1/private/edit-manage-level-income",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["manage-level-income"],
    }),

    addSystemWallet: builder.mutation({
      query: (body) => ({
        url: "/api/v1/private/add-system-wallet-info",
        method: "POST",
        body,
      }),
      invalidatesTags: ["system-wallet"],
    }),
    editSystemWallet: builder.mutation({
      query: (body) => ({
        url: "/api/v1/private/edit-system-wallet-info",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["system-wallet"],
    }),
    deleteSystemWallet: builder.mutation({
      query: (body) => ({
        url: "/api/v1/private/delete-system-wallet-info",
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["system-wallet"],
    }),

    getAllSystemWallet: builder.query({
      // SAST API
      query: (query) =>
        `/api/v1/private/get-system-wallet-info?page=${query?.page}&limit=${query?.limit}&searchById=${query.searchById}&startDate=${query.startDate}&endDate=${query.endDate}&csv=${query.csv}`,
      providesTags: ["system-wallet"], // automatic-data fetching
    }),
  }),
});

export const {
  useGetPopupImageQuery, //
  useGetYoutubeQuery, //
  useAddPdfLinkMutation,
  useGetPdfLinkQuery, //
  useGetWebsiteAnalyticsQuery, //
  useAddPopupImageMutation,
  useAddYoutubeVideoMutation,
  useAddRewardMutation, // SAST API
  useUpdateRewardMutation, // SAST API
  useDeleteRewardMutation, // SAST API
  useGetAdminRewardQuery, // SAST API
  useCreateAdminHomepageImageMutation,
  useCreateAdminHomepageVideoMutation,
  useGetAdminAllPhotosQuery,
  useGetAdminAllVideosQuery,
  useDeleteGalleryImageByAdminMutation,
  useDeleteGalleryVideoByAdminMutation,

  useAddManageROIMutation,
  useGetAllManageROIHistoryAdminQuery,
  useDeleteManageROIMutation,
  useEditManageROIMutation,
  //manage level income
  useAddManageLevelIncomeMutation,
  useGetAllManageLevelIncomeHistoryAdminQuery,
  useDeleteManageLevelIncomeMutation,
  useEditManageLevelIncomeMutation,

  useAddSystemWalletMutation,
  useGetAllSystemWalletQuery,
  useDeleteSystemWalletMutation,
  useEditSystemWalletMutation,
} = settingApi;
